import styled from 'styled-components';
import SWSLogoBlackSVG from '@assets/images/logo/sws-logo.svg';
import SWSLogoWhiteSVG from '@assets/images/logo/sws-logo-white.svg';
import { Column } from '@simplywallst/ui-core';

export const LogoBlack = styled(SWSLogoBlackSVG)`
  width: 100%;
  height: auto;
`;

export const LogoWhite = styled(SWSLogoWhiteSVG)`
  width: 100%;
  height: auto;
`;

export const LogoContainer = styled(Column)`
  margin-top: -4px;
`;
